import companyActionTypes from "../types/companyActionTypes";

const initialState = {
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null
    },
    companyInfo: null,
};


const companyReducer = (state = initialState, action) => {
    switch (action.type) {
        case companyActionTypes.RESET_STATE_INFO:
            return resetStateInfo(state, action);

        // ************* state info ************* 
        // ************* Loading ************* 
        case companyActionTypes.START_GET_COMPANY:
            return setStateLoading(state, action);

        // ************* success ************* 
        case companyActionTypes.GET_COMPANY_SUCCESS:
            return setGetCompanySuccess(state, action);
            
        // ************* failure ************* 
        case companyActionTypes.GET_COMPANY_FAILURE:
            return setActionFailed(state, action);
        default:
            return state;
    }
}

const resetStateInfo = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: false,
            isSuccess: false,
            isError: false,
            error: null
        }
    };
}

const setStateLoading = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: true,
            isSuccess: false,
            isError: false,
            error: null
        }
    };
}


const setActionFailed = (state, action) => {
    return {
        ...state,
        stateInfo: {
            isLoading: false,
            isSuccess: false,
            isError: true,
            error: action.payload
        },
    };
}

const setGetCompanySuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            isLoading: false,
            isSuccess: true,
            isError: false
        },
        companyInfo: action.payload
    };
}

export default companyReducer;